import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Check",
  "use": "Check-usage",
  "viewBox": "0 0 11 9",
  "content": "<symbol viewBox=\"0 0 11 9\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Check\"><path d=\"M179.9 303L173.666667 309.234067 171.1 306.666667 170 307.766667 173.666667 311.433333 181 304.1z\" transform=\"translate(-170 -303)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/Check.svg
// module id = 271
// module chunks = 0